





















import Vue from 'vue'
import CorrectIcon from '@/components/correct-icon/correct-icon.vue'
import VMarkdown from '@/components/v-markdown/v-markdown.vue'
import { indexToLabel } from '@/lib/functions'

export default Vue.extend({
  name: 'QuestionOption',
  props: {
    question: Object,
    option: Object,
    idx: Number,
    showSolution: Boolean
  },
  components: {
    VMarkdown,
    CorrectIcon
  },
  methods: {
    indexToLabel,

    clickOptionButton(event: any) {
      this.$emit('handle-click-check', event)
    }
  },
  computed: {
    showAnswer() {
      return this.showSolution && this.option.right_or_wrong
    },
    correct() {
      // 正解（true / false）を返す
      return this.question.impl.answers.includes(this.option.seq)
    }
  }
})
